module.exports = __webpack_public_path__ + "static/media/risk4.aac41864.jpg";